import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { DoctorsComponent, DoctorsService, FormDoctorComponent, ProfileComponent } from './';

@NgModule({
    declarations: [
        DoctorsComponent,
        FormDoctorComponent,
        ProfileComponent,
    ],
    imports: [SharedModule],
    providers: [
        DoctorsService
    ],
})
export class DoctorsModule { }
